// import { Bold } from 'lucide-react';
// import React, { useEffect, useRef } from 'react';

// const HighLightText = ({ value, onChange, type = 'text', placeholder,style, callingName ,...props   }) => {
//   const editorRef = useRef(null);

//   // Move caret to the end
//   const moveCaretToEnd = (el) => {
//     if (!el) return;
//     const range = document.createRange();
//     const selection = window.getSelection();
//     range.selectNodeContents(el);
//     range.collapse(false); // move caret to end
//     selection.removeAllRanges();
//     selection.addRange(range);
//   };

//   // Wrap selected text with element (strong / span)
//   const applySurround = (element) => {
//     const selection = window.getSelection();
//     if (!selection.rangeCount) return;

//     const range = selection.getRangeAt(0);
//     if (range.collapsed) return; // nothing selected

//     try {
//       range.surroundContents(element);
//     } catch (error) {
//       console.warn('Cannot wrap partially-selected elements.');
//       return;
//     }

//     // Move caret after the newly added element
//     range.setStartAfter(element);
//     range.setEndAfter(element);

//     selection.removeAllRanges();
//     selection.addRange(range);

//     onChange(editorRef.current.innerHTML);
//   };

//   const applyBold = () => {
//     const strong = document.createElement('strong');
//     applySurround(strong);
//   };

//   const applyHighlight = () => {
//     const span = document.createElement('span');
//     span.style.backgroundColor = 'yellow';
//     applySurround(span);
//   };

//   useEffect(() => {
//     if (editorRef.current) moveCaretToEnd(editorRef.current);
//   }, [value]);

//   // Dynamic style for text or textarea type
//   const editorStyle = {
//     minHeight: type === 'textarea' ? '80px' : '40px',
//     lineHeight: '1.5',
//     resize: type === 'textarea' ? 'vertical' : 'none',
//     overflow: 'auto',
//   };

//   return (
//     <div className="d-flex align-items-center  gap-2">
//       <div
//         ref={editorRef}
//         contentEditable
//         className="form-control"
//         style={style ? style : editorStyle}
//         suppressContentEditableWarning
//         onInput={(e) => onChange(e.currentTarget.innerHTML)}
//         onFocus={() => moveCaretToEnd(editorRef.current)}   
//         placeholder={placeholder || ''}
//         dangerouslySetInnerHTML={{ __html: value }}
//         {...props}
//       />

//      { callingName  !== 'providerEditNoteView' && <div className="d-flex   flex-column gap-1">
//         <button
//           type="button"
//           className="btn btn-sm btn-secondary"
//           style={{ whiteSpace: 'nowrap' }}
//           onClick={applyBold}
//         >
//            Bold
//         </button>
//         {/* <button
//           type="button"
//           className="btn btn-sm btn-warning"
//           style={{ whiteSpace: 'nowrap' }}
//           onClick={applyHighlight}
//         >
//           Highlight
//         </button> */}
//       </div>}
//     </div>
//   );
// };

// export default HighLightText;

 import PropTypes from 'prop-types';
 import React, { useEffect, useRef } from 'react';

const HighLightText = ({ value, onChange, type = 'text', placeholder, style, callingName, ...props }) => {
  const editorRef = useRef(null);
  const savedRangeRef = useRef(null);

 
  useEffect(() => {
    if (!editorRef.current) return;

    if (editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

 

  // Handle typing (NO DOM RESET)
  const handleInput = () => {
    if (!editorRef.current) return;
    onChange(editorRef.current.innerHTML);
  };

  const isSelectionInsideEditor = (range) => {
    const editor = editorRef.current;
    if (!editor || !range) return false;

    const { startContainer, endContainer } = range;
    return editor.contains(startContainer) && editor.contains(endContainer);
  };

  const captureSelection = () => {
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) {
      savedRangeRef.current = null;
      return;
    }

    const range = selection.getRangeAt(0);
    savedRangeRef.current = isSelectionInsideEditor(range) ? range.cloneRange() : null;
  };

  // Apply formatting
  const applySurround = (element) => {
    const selection = window.getSelection();
    const range = savedRangeRef.current;
    if (!selection || !range || !isSelectionInsideEditor(range) || range.collapsed) return;

    selection.removeAllRanges();
    selection.addRange(range);

    const activeRange = selection.getRangeAt(0);

    try {
      activeRange.surroundContents(element);
    } catch {
      return;
    }

    onChange(editorRef.current.innerHTML);
    savedRangeRef.current = null;
  };

  const applyHighlight = () => {
    const range = savedRangeRef.current;
    if (!range || !isSelectionInsideEditor(range) || range.collapsed) return;

    const parent =
      range.commonAncestorContainer.nodeType === 3
        ? range.commonAncestorContainer.parentNode
        : range.commonAncestorContainer;

    if (parent?.tagName === 'SPAN' && parent.style.color === 'orange' && editorRef.current?.contains(parent)) {
      const textNode = document.createTextNode(parent.textContent);
      parent.replaceWith(textNode);
      onChange(editorRef.current.innerHTML);
      savedRangeRef.current = null;
      return;
    }

    const span = document.createElement('span');
    span.style.color = 'orange';
    applySurround(span);
  };

  const editorStyle = {
    minHeight: type === 'textarea' ? '80px' : '40px',
    lineHeight: '1.5',
    resize: type === 'textarea' ? 'vertical' : 'none',
    overflow: 'auto',
  };

  return (
    <div className="ui-rich-editor d-flex align-items-start gap-2">
      <div
        ref={editorRef}
        contentEditable
        className={`form-control ui-rich-editor__field ${type === 'textarea' ? 'ui-rich-editor__field--textarea' : ''}`}
        style={style ? style : editorStyle}
        suppressContentEditableWarning
        onInput={handleInput}
        onMouseUp={captureSelection}
        onKeyUp={captureSelection}
        onFocus={captureSelection}
        onBlur={captureSelection}
        placeholder={placeholder || ''}
        {...props}
      />

      {callingName !== 'providerEditNoteView' && (
        <div className="d-flex flex-column gap-1">
          {/* <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={applyBold}
          >
            Bold
          </button> */}
              <button
          type="button"
          className={`btn btn-sm ui-action-btn ${callingName === 'callcenter' ? 'ui-action-btn--primary' : 'ui-action-btn--secondary'} ui-rich-editor__action`}
          style={{ whiteSpace: 'nowrap' }}
          onMouseDown={(e) => e.preventDefault()}
          onClick={applyHighlight}
        >
          Highlight
        </button> 
    
        </div>
      )}
    </div>
  );
};

HighLightText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  callingName: PropTypes.string,
};

export default HighLightText;
